// // if document is changed then this function will be called to update the cart drawer 
// function formatMoney(cents, format) {
//   if (typeof cents == 'string') {
//     cents = cents.replace('.', '');
//   }
//   var value = '';
//   var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
//   var formatString = (format || this.money_format);

//   function defaultOption(opt, def) {
//     return (typeof opt == 'undefined' ? def : opt);
//   }

//   function formatWithDelimiters(number, precision, thousands, decimal) {
//     precision = defaultOption(precision, 2);
//     thousands = defaultOption(thousands, ',');
//     decimal = defaultOption(decimal, '.');

//     if (isNaN(number) || number == null) {
//       return 0;
//     }

//     number = (number / 100.0).toFixed(precision);

//     var parts = number.split('.'),
//       dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
//       cents = parts[1] ? (decimal + parts[1]) : '';

//     return dollars + cents;
//   }

//   switch (formatString.match(placeholderRegex)[1]) {
//     case 'amount':
//       value = formatWithDelimiters(cents, 2);
//       break;
//     case 'amount_no_decimals':
//       value = formatWithDelimiters(cents, 0);
//       break;
//     case 'amount_with_comma_separator':
//       value = formatWithDelimiters(cents, 2, '.', ',');
//       break;
//     case 'amount_no_decimals_with_comma_separator':
//       value = formatWithDelimiters(cents, 0, '.', ',');
//       break;
//   }

//   return formatString.replace(placeholderRegex, value);
// };

// const cartDrawer = document.querySelector('#cart-drawer');
// const cartDrawerClose = document.querySelectorAll('#close-cart');
// var loaderSkeleton = document.querySelector('.loader__skeleton');
// const body = document.body;

// // This function is used to fetch the cart drawer data from a end point i have created in the template with no layout containing the liquid code to append. 
// async function refreshCartDrawer() {
//   loaderSkeleton.style.display = 'block';
//   fetch('?section_id=cart-drawer')
//     .then(function (response) {
//       return response.text();
//     })
//     .then(function (cartData) {
//       const parser = new DOMParser();
//       const htmlDoc = parser.parseFromString(cartData, 'text/html');
//       const bodyContent = htmlDoc.querySelector('.cart-drawer__body').innerHTML;
//       document.querySelector('.cart-drawer__body').innerHTML = bodyContent;
//       const cartCount = document.querySelector('#cart-drawer__form').getAttribute('data-cart-count');
//       const basketCount = document.querySelector('#CartCount [data-cart-count]');
//       basketCount.innerHTML = cartCount;

//       if (cartCount == 0) {
//         document.querySelector('#CartCount').classList.add('hide');
//       } else {
//         document.querySelector('#CartCount').classList.remove('hide');
//       }

//       loaderSkeleton.style.display = 'none';
//     });
// }

// async function toggleCartDrawer(isOpen) {
//   const cartDrawer = document.querySelector('.cart-drawer');
//   const cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
 
//   if (isOpen) {
   
//     setTimeout(() => {
//       refreshCartDrawer();
//       cartDrawer.style.transform = 'translateX(0)';
//       cartDrawerOverlay.style.display = 'block';
//       body.classList.add('cart-drawer-open');
      
//     }, 500);
//   } else {
//     cartDrawer.style.transform = 'translateX(100%)';
//     cartDrawerOverlay.style.display = 'none';
//     body.classList.remove('cart-drawer-open');
//   }
// }


// const toggleCartDrawerButtons = document.querySelectorAll('[toggle-cart-drawer]');
// toggleCartDrawerButtons.forEach((button) => {
//   button.addEventListener('click', () => toggleCartDrawer(true));
// });

// const elementsToTriggerCartDrawer = '.product-form__cart-submit';
// const elementsToTrigger = document.querySelectorAll(elementsToTriggerCartDrawer);
// elementsToTrigger.forEach((element) => {
//   element.addEventListener('click', () => {
//       setTimeout(() => {
//       refreshCartDrawer();
//       toggleCartDrawer(true);
//     }, 500);
//   });
// });

// /// Function for close the cart drawer 
// cartDrawerClose.forEach(function (button) {
//   button.addEventListener('click', function () {
//     cartDrawer.style.transform = 'translateX(100%)';
//     document.querySelector('.cart-drawer-overlay').style.display = 'none';
//     body.classList.remove('cart-drawer-open');
//   });
// });

// // Function on click to add product from quick add to cart drawer

// document.querySelector('body').addEventListener('click', function (e) {
//   if (e.target.id === ('quick-add') || e.target.classList.contains('product-form--atc-button')) {
//     refreshCartDrawer();
//     toggleCartDrawer(true);
//   }
// });

// // This function is for updating the quantity for each item in the cart drawer, and it is then calling the updateQunaity function

// document.querySelector('.cart-drawer__body').addEventListener('click', function (e) {
//   console.log(e.target.classList);
//   if (e.target.classList.contains('cart-drawer-quantity__minus')) {
//     console.log('minus clicked');
//     const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
//     const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
//     const quantity = parseInt(cartDrawerQuantityVal.value, 10) - 1;
//     if (quantity >= 0) {
//       updateCart(itemId, quantity, 'updateItemQty');
//     }
//   }
//   if (e.target.classList.contains('cart-drawer-quantity__plus')) {
//     console.log('plus clicked');
//     const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
//     const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
//     const quantity = parseInt(cartDrawerQuantityVal.value, 10) + 1;
//     updateCart(itemId, quantity, 'updateItemQty');
//   }
//   if (e.target.classList.contains('cart-drawer__item-delete')) {
//     console.log('delete clicked');
//     const itemId = e.target.getAttribute('data-item-id');
//     updateCart(itemId, 0,'removeItem' )
//   }

//   if (e.target.classList.contains('product-form__cart-submit')) {
//     e.preventDefault();
//     const upsellBtn = e.target;
//     const upsellId = upsellBtn.getAttribute('data-varaint');
//     const quantity = 1;
//     addToCart(upsellId, quantity);
//   }
// });

// // this function handles the update item quanity as well as the remove item from the cart as it takes the type as a parameter
// async function updateCart(itemId, quantity, type) {
//   try {
//     // Fetch the current cart
//     const res = await fetch('/cart.js'); 
//     const cart = await res.json(); 
//     const item = cart.items.find((item) => (item.key == itemId));

//     // Check if the item is already at the desired quantity for update and return if true
//     if (type === 'updateItemQty' && item.quantity === quantity) return;

//     // Make a request to update or delete the item in the cart 
//     let updatedRes;
//     if (type === 'updateItemQty') {
//        updatedRes = await fetch('/cart/change.js', {
//          method: 'POST',
//          headers: {
//            'Content-Type': 'application/json'
//          },
//          body: JSON.stringify({
//            id: itemId,
//            quantity: quantity
//          })
//        });
//     } else if (type === 'removeItem') {
//        updatedRes = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           id: itemId,
//           quantity: quantity
//         })
//        });
//     }
//     const updatedCart = await updatedRes.json();

//     if (type === 'updateItemQty') {

//         // const updatedItem = updatedCart.items.find((item) => (item.key == itemId));
//         // // const itemPrice = updatedItem.final_line_price;
//         // const moneyFormat = document.getElementById('cart-drawer').getAttribute('data-money-format');
//         // const cartDrawerSubtotalPrice = document.querySelector('.cart-drawer-subtotal__price');
//         // const cartDrawerItemPrice = document.querySelector(`[data-item-id="${itemId}"] .cart-drawer__item-price`);
//         // cartDrawerSubtotalPrice.innerHTML = formatMoney(updatedCart.total_price, moneyFormat);
//         // cartDrawerItemPrice.innerHTML = formatMoney(itemPrice, moneyFormat);
//         refreshCartDrawer();

//     } else if (type === 'removeItem') {
//         loaderSkeleton.style.display = 'block';
//         if (cart.items.length === 0) {
//           cartDrawer.style.transform = 'translateX(100%)';
//           document.querySelector('.cart-drawer-overlay').style.display = 'none';
//           body.classList.remove('cart-drawer-open');
//           document.querySelector('#cart-drawer__form').remove();
//           const emptyState = document.createElement('div');
//           emptyState.innerHTML = `
//             <div class="cart-drawer__empty">
//               <p class="cart-drawer__empty-text"> Your Basket is empty </p>
//               <span> Add your favorite items to your cart.</span>
//               <a class="cart-drawer__empty-btn" href="/"> Shop Now <a>
//             </div>`;
//           document.querySelector('.cart-drawer .cart-drawer__body').appendChild(emptyState);
//         } else {
//           const removeItem = document.querySelector('.cart-drawer__item[data-item-id="' + itemId + '"]');
    
//           loaderSkeleton.style.display = 'none';
    
//           removeItem.remove();
//           await refreshCartDrawer();
//         }
//       }
//   } catch (error) {
//     console.error('Error updating cart:', error);
//   }
// }

// //get add to cart to work with collection page and its products. 
// // const quickAdd = document.querySelector('[data-add-to-cart-text]');
// // console.log(quickAdd);
// // if (quickAdd) {
// //   quickAdd.addEventListener('click', function (e) {
// //       if (e.target.classList.contains('btn product-form__cart-submit')) {
// //           e.preventDefault();
// //           const inputValue = e.target.parentElement.querySelector('.variant-selection').value;
// //           const inputQuantity = e.target.parentElement.querySelector('input').value;
// //           addToCart(inputValue, inputQuantity);
// //       }
// //   });
// // }

// async function addToCart(id, quantity) {

//   try{
//     const res = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         id: id,
//         quantity: quantity
//       })
//     });
//    // IF RESPONSE IS 200 THEN SHOW THE CART DRAWER
//     if (res.status === 200) {
//       refreshCartDrawer();
//       toggleCartDrawer(true);
//     }

//   }catch(err){
//     console.log(err);

//   }
// }
// const quickAddCollection = document.querySelectorAll('.main-collection-quick-add');
// console.log(quickAddCollection);
// if (quickAddCollection) {
//   quickAddCollection.forEach((product) => {
//     product.addEventListener('click', function (e) {
//       if (e.target.classList.contains('quick-search')) {
//         return;
//       }
//       else if (e.target.classList.contains('btn--submit')) {
//         console.log('clicked');
//         e.preventDefault();
//         const input = e.target.parentElement.querySelector('#varaint-id__input');
//         const inputValue = input ? input.value : null;
//         const bundleQuantity = e.target.parentElement.querySelector('input').value;
//         console.log(inputValue);
//         console.log(bundleQuantity);
//         if (inputValue !== null) {
//           console.log(inputValue);
//           addToCart(inputValue, bundleQuantity);
//         }
//       }
//     });
//   });
// }






// /* ===============================
//    MONEY FORMAT
// ================================= */
// function formatMoney(cents, format) {
//   if (typeof cents === 'string') cents = cents.replace('.', '');

//   const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
//   const formatString = format || window.money_format;
//   let value = '';

//   function defaultOption(opt, def) {
//     return typeof opt === 'undefined' ? def : opt;
//   }

//   function formatWithDelimiters(number, precision, thousands, decimal) {
//     precision = defaultOption(precision, 2);
//     thousands = defaultOption(thousands, ',');
//     decimal = defaultOption(decimal, '.');

//     if (isNaN(number) || number == null) return 0;

//     number = (number / 100.0).toFixed(precision);

//     const parts = number.split('.');
//     const dollars = parts[0].replace(
//       /(\d)(?=(\d\d\d)+(?!\d))/g,
//       '$1' + thousands
//     );
//     const centsAmount = parts[1] ? decimal + parts[1] : '';

//     return dollars + centsAmount;
//   }

//   switch (formatString.match(placeholderRegex)[1]) {
//     case 'amount':
//       value = formatWithDelimiters(cents, 2);
//       break;
//     case 'amount_no_decimals':
//       value = formatWithDelimiters(cents, 0);
//       break;
//     case 'amount_with_comma_separator':
//       value = formatWithDelimiters(cents, 2, '.', ',');
//       break;
//     case 'amount_no_decimals_with_comma_separator':
//       value = formatWithDelimiters(cents, 0, '.', ',');
//       break;
//   }

//   return formatString.replace(placeholderRegex, value);
// }

// /* ===============================
//    GLOBAL ELEMENTS
// ================================= */
// const body = document.body;
// const loaderSkeleton = document.querySelector('.loader__skeleton');

// /* ===============================
//    CART DRAWER TOGGLE
// ================================= */
// async function toggleCartDrawer(isOpen) {
//   const cartDrawer = document.querySelector('.cart-drawer');
//   const overlay = document.querySelector('.cart-drawer-overlay');

//   if (!cartDrawer || !overlay) return;

//   if (isOpen) {
//     cartDrawer.style.transform = 'translateX(0)';
//     overlay.style.display = 'block';
//     body.classList.add('cart-drawer-open');
//   } else {
//     cartDrawer.style.transform = 'translateX(100%)';
//     overlay.style.display = 'none';
//     body.classList.remove('cart-drawer-open');
//   }
// }

// /* ===============================
//    REFRESH CART DRAWER
// ================================= */
// async function refreshCartDrawer() {
//   try {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'block';

//     const response = await fetch('?section_id=cart-drawer');
//     const cartData = await response.text();

//     const parser = new DOMParser();
//     const htmlDoc = parser.parseFromString(cartData, 'text/html');

//     const newBody = htmlDoc.querySelector('.cart-drawer__body');
//     if (!newBody) return;

//     const currentBody = document.querySelector('.cart-drawer__body');
//     if (currentBody) {
//       currentBody.innerHTML = newBody.innerHTML;
//     }

//     const cartForm = htmlDoc.querySelector('#cart-drawer__form');
//     const cartCount = cartForm
//       ? parseInt(cartForm.getAttribute('data-cart-count'), 10)
//       : 0;

//     const basketCount = document.querySelector('#CartCount [data-cart-count]');
//     const cartCountWrapper = document.querySelector('#CartCount');

//     if (basketCount) basketCount.innerHTML = cartCount;

//     if (cartCountWrapper) {
//       if (cartCount === 0) {
//         cartCountWrapper.classList.add('hide');
//       } else {
//         cartCountWrapper.classList.remove('hide');
//       }
//     }

//     initializeCartDrawerEvents();
//   } catch (error) {
//     console.error('Error refreshing cart drawer:', error);
//   } finally {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'none';
//   }
// }

// /* ===============================
//    ADD TO CART
// ================================= */
// async function addToCart(id, quantity = 1) {
//   try {
//     if (!id) return;

//     if (loaderSkeleton) loaderSkeleton.style.display = 'block';

//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: id,
//         quantity: quantity,
//       }),
//     });

//     if (!response.ok) {
//       throw new Error('Failed to add product');
//     }

//     await refreshCartDrawer();
//     await toggleCartDrawer(true);
//   } catch (error) {
//     console.error('Error adding to cart:', error);
//   } finally {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'none';
//   }
// }

// /* ===============================
//    UPDATE CART
// ================================= */
// async function updateCart(itemId, quantity) {
//   try {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'block';

//     const response = await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: itemId,
//         quantity: quantity,
//       }),
//     });

//     if (!response.ok) {
//       throw new Error('Failed to update cart');
//     }

//     await refreshCartDrawer();

//     const cartResponse = await fetch('/cart.js');
//     const cart = await cartResponse.json();

//     if (cart.item_count === 0) {
//       toggleCartDrawer(false);
//     }
//   } catch (error) {
//     console.error('Error updating cart:', error);
//   } finally {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'none';
//   }
// }

// /* ===============================
//    INITIALIZE CART DRAWER EVENTS
// ================================= */
// function initializeCartDrawerEvents() {
//   const closeButtons = document.querySelectorAll('#close-cart');
//   const overlay = document.querySelector('.cart-drawer-overlay');

//   closeButtons.forEach((button) => {
//     button.onclick = () => toggleCartDrawer(false);
//   });

//   if (overlay) {
//     overlay.onclick = () => toggleCartDrawer(false);
//   }
// }

// /* ===============================
//    GLOBAL EVENT DELEGATION
// ================================= */
// document.body.addEventListener('click', async function (e) {
//   /* OPEN CART */
//   if (
//     e.target.matches('[toggle-cart-drawer]') ||
//     e.target.closest('[toggle-cart-drawer]')
//   ) {
//     e.preventDefault();
//     await refreshCartDrawer();
//     await toggleCartDrawer(true);
//   }

//   /* PRODUCT PAGE ADD TO CART */
//   if (
//     e.target.matches('.product-form__cart-submit') ||
//     e.target.closest('.product-form__cart-submit')
//   ) {
//     const button = e.target.closest('.product-form__cart-submit');

//     if (
//       button &&
//       !button.hasAttribute('data-ajax-cart') &&
//       !button.classList.contains('cart-drawer-processed')
//     ) {
//       e.preventDefault();

//       const form =
//         button.closest('form') ||
//         document.querySelector('form[action="/cart/add"]');

//       if (!form) return;

//       const variantInput = form.querySelector('[name="id"]');
//       const quantityInput = form.querySelector('[name="quantity"]');

//       const variantId = variantInput ? variantInput.value : null;
//       const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

//       if (variantId) {
//         await addToCart(variantId, quantity);
//       }
//     }
//   }

//   /* QUICK ADD */
//   if (
//     e.target.id === 'quick-add' ||
//     e.target.classList.contains('product-form--atc-button')
//   ) {
//     e.preventDefault();

//     const variantId =
//       e.target.getAttribute('data-variant') ||
//       e.target.getAttribute('data-varaint');

//     if (variantId) {
//       await addToCart(variantId, 1);
//     }
//   }

//   /* COLLECTION QUICK ADD */
//   if (e.target.classList.contains('btn--submit')) {
//     e.preventDefault();

//     const parent = e.target.closest('.main-collection-quick-add');
//     if (!parent) return;

//     const variantInput = parent.querySelector('#varaint-id__input');
//     const quantityInput = parent.querySelector('input[type="number"]');

//     const variantId = variantInput ? variantInput.value : null;
//     const quantity = quantityInput
//       ? parseInt(quantityInput.value, 10)
//       : 1;

//     if (variantId) {
//       await addToCart(variantId, quantity);
//     }
//   }

//   /* QUANTITY MINUS */
//   if (e.target.classList.contains('cart-drawer-quantity__minus')) {
//     e.preventDefault();

//     const quantityInput = e.target
//       .closest('.cart-drawer-quantity')
//       ?.querySelector('.cart-drawer__item-quantity__val');

//     if (!quantityInput) return;

//     const itemId = quantityInput.getAttribute('data-item-id');
//     const quantity = Math.max(
//       parseInt(quantityInput.value, 10) - 1,
//       0
//     );

//     await updateCart(itemId, quantity);
//   }

//   /* QUANTITY PLUS */
//   if (e.target.classList.contains('cart-drawer-quantity__plus')) {
//     e.preventDefault();

//     const quantityInput = e.target
//       .closest('.cart-drawer-quantity')
//       ?.querySelector('.cart-drawer__item-quantity__val');

//     if (!quantityInput) return;

//     const itemId = quantityInput.getAttribute('data-item-id');
//     const quantity = parseInt(quantityInput.value, 10) + 1;

//     await updateCart(itemId, quantity);
//   }

//   /* DELETE ITEM */
//   if (e.target.classList.contains('cart-drawer__item-delete')) {
//     e.preventDefault();

//     const itemId = e.target.getAttribute('data-item-id');
//     if (itemId) {
//       await updateCart(itemId, 0);
//     }
//   }
// });

// /* ===============================
//    VARIANT CHANGE SUPPORT
// ================================= */
// document.addEventListener('change', function (e) {
//   if (
//     e.target.matches('select[name="id"]') ||
//     e.target.matches('input[name="id"]')
//   ) {
//     setTimeout(() => {
//       initializeCartDrawerEvents();
//     }, 300);
//   }
// });

// /* ===============================
//    PAGE LOAD
// ================================= */
// document.addEventListener('DOMContentLoaded', function () {
//   initializeCartDrawerEvents();
// });





// /* ===============================
//    MONEY FORMAT
// ================================= */
// function formatMoney(cents, format) {
//   if (typeof cents === 'string') cents = cents.replace('.', '');

//   const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
//   const formatString = format || window.money_format;
//   let value = '';

//   function defaultOption(opt, def) {
//     return typeof opt === 'undefined' ? def : opt;
//   }

//   function formatWithDelimiters(number, precision, thousands, decimal) {
//     precision = defaultOption(precision, 2);
//     thousands = defaultOption(thousands, ',');
//     decimal = defaultOption(decimal, '.');

//     if (isNaN(number) || number == null) return 0;

//     number = (number / 100.0).toFixed(precision);

//     const parts = number.split('.');
//     const dollars = parts[0].replace(
//       /(\d)(?=(\d\d\d)+(?!\d))/g,
//       '$1' + thousands
//     );
//     const centsAmount = parts[1] ? decimal + parts[1] : '';

//     return dollars + centsAmount;
//   }

//   switch (formatString.match(placeholderRegex)[1]) {
//     case 'amount':
//       value = formatWithDelimiters(cents, 2);
//       break;
//     case 'amount_no_decimals':
//       value = formatWithDelimiters(cents, 0);
//       break;
//     case 'amount_with_comma_separator':
//       value = formatWithDelimiters(cents, 2, '.', ',');
//       break;
//     case 'amount_no_decimals_with_comma_separator':
//       value = formatWithDelimiters(cents, 0, '.', ',');
//       break;
//   }

//   return formatString.replace(placeholderRegex, value);
// }

// /* ===============================
//    GLOBAL ELEMENTS
// ================================= */
// const body = document.body;
// const loaderSkeleton = document.querySelector('.loader__skeleton');

// /* ===============================
//    CART DRAWER TOGGLE
// ================================= */
// async function toggleCartDrawer(isOpen) {
//   const cartDrawer = document.querySelector('.cart-drawer');
//   const overlay = document.querySelector('.cart-drawer-overlay');

//   if (!cartDrawer || !overlay) return;

//   if (isOpen) {
//     cartDrawer.style.transform = 'translateX(0)';
//     overlay.style.display = 'block';
//     body.classList.add('cart-drawer-open');
//   } else {
//     cartDrawer.style.transform = 'translateX(100%)';
//     overlay.style.display = 'none';
//     body.classList.remove('cart-drawer-open');
//   }
// }

// /* ===============================
//    REFRESH CART DRAWER
// ================================= */
// async function refreshCartDrawer() {
//   try {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'block';

//     const response = await fetch('?section_id=cart-drawer');
//     const cartData = await response.text();

//     const parser = new DOMParser();
//     const htmlDoc = parser.parseFromString(cartData, 'text/html');

//     const newBody = htmlDoc.querySelector('.cart-drawer__body');
//     const currentBody = document.querySelector('.cart-drawer__body');

//     if (newBody && currentBody) {
//       currentBody.innerHTML = newBody.innerHTML;
//     }

//     const cartForm = htmlDoc.querySelector('#cart-drawer__form');
//     const cartCount = cartForm
//       ? parseInt(cartForm.getAttribute('data-cart-count'), 10)
//       : 0;

//     const basketCount = document.querySelector('#CartCount [data-cart-count]');
//     const cartCountWrapper = document.querySelector('#CartCount');

//     if (basketCount) basketCount.innerHTML = cartCount;

//     if (cartCountWrapper) {
//       if (cartCount === 0) {
//         cartCountWrapper.classList.add('hide');
//       } else {
//         cartCountWrapper.classList.remove('hide');
//       }
//     }

//     initializeCartDrawerEvents();
//   } catch (error) {
//     console.error('Error refreshing cart drawer:', error);
//   } finally {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'none';
//   }
// }

// /* ===============================
//    ADD TO CART
// ================================= */
// async function addToCart(id, quantity = 1) {
//   try {
//     if (!id) return;

//     if (loaderSkeleton) loaderSkeleton.style.display = 'block';

//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: id,
//         quantity: quantity,
//       }),
//     });

//     if (!response.ok) {
//       throw new Error('Failed to add product');
//     }

//     await refreshCartDrawer();
//     await toggleCartDrawer(true);
//   } catch (error) {
//     console.error('Error adding to cart:', error);
//   } finally {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'none';
//   }
// }

// /* ===============================
//    UPDATE CART
// ================================= */
// async function updateCart(itemId, quantity) {
//   try {
//     if (!itemId) return;

//     if (loaderSkeleton) loaderSkeleton.style.display = 'block';

//     const response = await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: itemId,
//         quantity: quantity,
//       }),
//     });

//     if (!response.ok) {
//       throw new Error('Failed to update cart');
//     }

//     const updatedCart = await response.json();

//     await refreshCartDrawer();

//     if (updatedCart.item_count === 0) {
//       await toggleCartDrawer(false);
//     }
//   } catch (error) {
//     console.error('Error updating cart:', error);
//   } finally {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'none';
//   }
// }

// /* ===============================
//    INITIALIZE CART DRAWER EVENTS
// ================================= */
// function initializeCartDrawerEvents() {
//   const closeButtons = document.querySelectorAll('#close-cart');
//   const overlay = document.querySelector('.cart-drawer-overlay');

//   closeButtons.forEach((button) => {
//     button.onclick = () => toggleCartDrawer(false);
//   });

//   if (overlay) {
//     overlay.onclick = () => toggleCartDrawer(false);
//   }
// }

// /* ===============================
//    GLOBAL CLICK EVENTS
// ================================= */
// document.body.addEventListener('click', async function (e) {

//   /* OPEN CART DRAWER */
//   if (
//     e.target.matches('[toggle-cart-drawer]') ||
//     e.target.closest('[toggle-cart-drawer]')
//   ) {
//     e.preventDefault();
//     await refreshCartDrawer();
//     await toggleCartDrawer(true);
//     return;
//   }

//   /* PRODUCT PAGE ADD TO CART */
//   const productCartBtn = e.target.closest('.product-form__cart-submit');
//   if (productCartBtn) {
//     e.preventDefault();

//     const form =
//       productCartBtn.closest('form') ||
//       document.querySelector('form[action="/cart/add"]');

//     if (!form) return;

//     const variantInput = form.querySelector('[name="id"]');
//     const quantityInput = form.querySelector('[name="quantity"]');

//     const variantId = variantInput ? variantInput.value : null;
//     const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

//     if (variantId) {
//       await addToCart(variantId, quantity);
//     }
//     return;
//   }

//   /* QUICK ADD */
//   if (
//     e.target.id === 'quick-add' ||
//     e.target.classList.contains('product-form--atc-button')
//   ) {
//     e.preventDefault();

//     const variantId =
//       e.target.getAttribute('data-variant') ||
//       e.target.getAttribute('data-varaint');

//     if (variantId) {
//       await addToCart(variantId, 1);
//     }
//     return;
//   }

//   /* COLLECTION QUICK ADD */
//   if (e.target.classList.contains('btn--submit')) {
//     e.preventDefault();

//     const parent = e.target.closest('.main-collection-quick-add');
//     if (!parent) return;

//     const variantInput = parent.querySelector('#varaint-id__input');
//     const quantityInput = parent.querySelector('input[type="number"]');

//     const variantId = variantInput ? variantInput.value : null;
//     const quantity = quantityInput
//       ? parseInt(quantityInput.value, 10)
//       : 1;

//     if (variantId) {
//       await addToCart(variantId, quantity);
//     }
//     return;
//   }

//   /* CART QTY MINUS */
//   const minusBtn = e.target.closest('.cart-drawer-quantity__minus');
//   if (minusBtn) {
//     e.preventDefault();

//     const wrapper = minusBtn.closest('.cart-drawer-quantity');
//     if (!wrapper) return;

//     const quantityInput = wrapper.querySelector(
//       '.cart-drawer__item-quantity__val'
//     );

//     if (!quantityInput) return;

//     const itemId = quantityInput.getAttribute('data-item-id');
//     const currentQty = parseInt(quantityInput.value, 10) || 1;
//     const newQty = Math.max(currentQty - 1, 0);

//     await updateCart(itemId, newQty);
//     return;
//   }

//   /* CART QTY PLUS */
//   const plusBtn = e.target.closest('.cart-drawer-quantity__plus');
//   if (plusBtn) {
//     e.preventDefault();

//     const wrapper = plusBtn.closest('.cart-drawer-quantity');
//     if (!wrapper) return;

//     const quantityInput = wrapper.querySelector(
//       '.cart-drawer__item-quantity__val'
//     );

//     if (!quantityInput) return;

//     const itemId = quantityInput.getAttribute('data-item-id');
//     const currentQty = parseInt(quantityInput.value, 10) || 1;
//     const newQty = currentQty + 1;

//     await updateCart(itemId, newQty);
//     return;
//   }

//   /* REMOVE ITEM */
//   const deleteBtn = e.target.closest('.cart-drawer__item-delete');
//   if (deleteBtn) {
//     e.preventDefault();

//     const itemId = deleteBtn.getAttribute('data-item-id');

//     if (itemId) {
//       await updateCart(itemId, 0);
//     }
//     return;
//   }
// });

// /* ===============================
//    VARIANT CHANGE SUPPORT
// ================================= */
// document.addEventListener('change', function (e) {
//   if (
//     e.target.matches('select[name="id"]') ||
//     e.target.matches('input[name="id"]')
//   ) {
//     setTimeout(() => {
//       initializeCartDrawerEvents();
//     }, 300);
//   }
// });

// /* ===============================
//    PAGE LOAD
// ================================= */
// document.addEventListener('DOMContentLoaded', function () {
//   initializeCartDrawerEvents();
// });








// /* ===============================
//    MONEY FORMAT
// ================================= */
// function formatMoney(cents, format) {
//   if (typeof cents === 'string') cents = cents.replace('.', '');

//   const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
//   const formatString = format || window.money_format;
//   let value = '';

//   function defaultOption(opt, def) {
//     return typeof opt === 'undefined' ? def : opt;
//   }

//   function formatWithDelimiters(number, precision, thousands, decimal) {
//     precision = defaultOption(precision, 2);
//     thousands = defaultOption(thousands, ',');
//     decimal = defaultOption(decimal, '.');

//     if (isNaN(number) || number == null) return 0;

//     number = (number / 100.0).toFixed(precision);

//     const parts = number.split('.');
//     const dollars = parts[0].replace(
//       /(\d)(?=(\d\d\d)+(?!\d))/g,
//       '$1' + thousands
//     );
//     const centsAmount = parts[1] ? decimal + parts[1] : '';

//     return dollars + centsAmount;
//   }

//   switch (formatString.match(placeholderRegex)[1]) {
//     case 'amount':
//       value = formatWithDelimiters(cents, 2);
//       break;
//     case 'amount_no_decimals':
//       value = formatWithDelimiters(cents, 0);
//       break;
//     case 'amount_with_comma_separator':
//       value = formatWithDelimiters(cents, 2, '.', ',');
//       break;
//     case 'amount_no_decimals_with_comma_separator':
//       value = formatWithDelimiters(cents, 0, '.', ',');
//       break;
//   }

//   return formatString.replace(placeholderRegex, value);
// }

// /* ===============================
//    GLOBAL ELEMENTS
// ================================= */
// const body = document.body;
// const loaderSkeleton = document.querySelector('.loader__skeleton');

// /* ===============================
//    CART DRAWER TOGGLE
// ================================= */
// async function toggleCartDrawer(isOpen) {
//   const cartDrawer = document.querySelector('.cart-drawer');
//   const overlay = document.querySelector('.cart-drawer-overlay');

//   if (!cartDrawer || !overlay) return;

//   if (isOpen) {
//     cartDrawer.style.transform = 'translateX(0)';
//     overlay.style.display = 'block';
//     body.classList.add('cart-drawer-open');
//   } else {
//     cartDrawer.style.transform = 'translateX(100%)';
//     overlay.style.display = 'none';
//     body.classList.remove('cart-drawer-open');
//   }
// }

// /* ===============================
//    REFRESH CART DRAWER
// ================================= */
// async function refreshCartDrawer() {
//   try {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'block';

//     const response = await fetch('?section_id=cart-drawer');
//     const cartData = await response.text();

//     const parser = new DOMParser();
//     const htmlDoc = parser.parseFromString(cartData, 'text/html');

//     const newBody = htmlDoc.querySelector('.cart-drawer__body');
//     const currentBody = document.querySelector('.cart-drawer__body');

//     if (newBody && currentBody) {
//       currentBody.innerHTML = newBody.innerHTML;
//     }

//     const cartForm = htmlDoc.querySelector('#cart-drawer__form');
//     const cartCount = cartForm
//       ? parseInt(cartForm.getAttribute('data-cart-count'), 10)
//       : 0;

//     const basketCount = document.querySelector('#CartCount [data-cart-count]');
//     const cartCountWrapper = document.querySelector('#CartCount');

//     if (basketCount) basketCount.innerHTML = cartCount;

//     if (cartCountWrapper) {
//       if (cartCount === 0) {
//         cartCountWrapper.classList.add('hide');
//       } else {
//         cartCountWrapper.classList.remove('hide');
//       }
//     }

//     initializeCartDrawerEvents();
//   } catch (error) {
//     console.error('Error refreshing cart drawer:', error);
//   } finally {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'none';
//   }
// }

// /* ===============================
//    ADD TO CART
// ================================= */
// async function addToCart(id, quantity = 1) {
//   try {
//     if (!id) return;

//     if (loaderSkeleton) loaderSkeleton.style.display = 'block';

//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: id,
//         quantity: quantity,
//       }),
//     });

//     if (!response.ok) {
//       throw new Error('Failed to add product');
//     }

//     await refreshCartDrawer();
//     await toggleCartDrawer(true);
//   } catch (error) {
//     console.error('Error adding to cart:', error);
//   } finally {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'none';
//   }
// }

// /* ===============================
//    UPDATE CART
// ================================= */
// async function updateCart(itemId, quantity) {
//   try {
//     if (!itemId) return;

//     if (loaderSkeleton) loaderSkeleton.style.display = 'block';

//     const response = await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: itemId,
//         quantity: quantity,
//       }),
//     });

//     if (!response.ok) {
//       throw new Error('Failed to update cart');
//     }

//     const updatedCart = await response.json();

//     await refreshCartDrawer();

//     if (updatedCart.item_count === 0) {
//       await toggleCartDrawer(false);
//     }
//   } catch (error) {
//     console.error('Error updating cart:', error);
//   } finally {
//     if (loaderSkeleton) loaderSkeleton.style.display = 'none';
//   }
// }

// /* ===============================
//    INITIALIZE CART DRAWER EVENTS
// ================================= */
// function initializeCartDrawerEvents() {
//   const closeButtons = document.querySelectorAll('#close-cart');
//   const overlay = document.querySelector('.cart-drawer-overlay');

//   closeButtons.forEach((button) => {
//     button.onclick = () => toggleCartDrawer(false);
//   });

//   if (overlay) {
//     overlay.onclick = () => toggleCartDrawer(false);
//   }
// }

// /* ===============================
//    GLOBAL CLICK EVENTS
// ================================= */
// document.body.addEventListener('click', async function (e) {

//   /* OPEN CART DRAWER */
//   if (
//     e.target.matches('[toggle-cart-drawer]') ||
//     e.target.closest('[toggle-cart-drawer]')
//   ) {
//     e.preventDefault();
//     await refreshCartDrawer();
//     await toggleCartDrawer(true);
//     return;
//   }

//   /* PRODUCT PAGE ADD TO CART */
//   const productCartBtn = e.target.closest('.product-form__cart-submit');
//   if (productCartBtn) {
//     e.preventDefault();

//     const form =
//       productCartBtn.closest('form') ||
//       document.querySelector('form[action="/cart/add"]');

//     if (!form) return;

//     const variantInput = form.querySelector('[name="id"]');
//     const quantityInput = form.querySelector('[name="quantity"]');

//     const variantId = variantInput ? variantInput.value : null;
//     const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

//     if (variantId) {
//       await addToCart(variantId, quantity);
//     }
//     return;
//   }

//   /* QUICK ADD */
//   if (
//     e.target.id === 'quick-add' ||
//     e.target.classList.contains('product-form--atc-button')
//   ) {
//     e.preventDefault();

//     const variantId =
//       e.target.getAttribute('data-variant') ||
//       e.target.getAttribute('data-varaint');

//     if (variantId) {
//       await addToCart(variantId, 1);
//     }
//     return;
//   }

//   /* COLLECTION QUICK ADD */
//   if (e.target.classList.contains('btn--submit')) {
//     e.preventDefault();

//     const parent = e.target.closest('.main-collection-quick-add');
//     if (!parent) return;

//     const variantInput = parent.querySelector('#varaint-id__input');
//     const quantityInput = parent.querySelector('input[type="number"]');

//     const variantId = variantInput ? variantInput.value : null;
//     const quantity = quantityInput
//       ? parseInt(quantityInput.value, 10)
//       : 1;

//     if (variantId) {
//       await addToCart(variantId, quantity);
//     }
//     return;
//   }

//   /* CART QTY MINUS */
//   if (e.target.classList.contains('cart-drawer-quantity__minus')) {
//     e.preventDefault();

//     const quantityInput = e.target.parentElement.querySelector(
//       '.cart-drawer__item-quantity__val'
//     );

//     if (!quantityInput) return;

//     const itemId = quantityInput.getAttribute('data-item-id');
//     const currentQty = parseInt(quantityInput.value, 10) || 1;
//     const newQty = Math.max(currentQty - 1, 0);

//     await updateCart(itemId, newQty);
//     return;
//   }

//   /* CART QTY PLUS */
//   if (e.target.classList.contains('cart-drawer-quantity__plus')) {
//     e.preventDefault();

//     const quantityInput = e.target.parentElement.querySelector(
//       '.cart-drawer__item-quantity__val'
//     );

//     if (!quantityInput) return;

//     const itemId = quantityInput.getAttribute('data-item-id');
//     const currentQty = parseInt(quantityInput.value, 10) || 1;
//     const newQty = currentQty + 1;

//     await updateCart(itemId, newQty);
//     return;
//   }

//   /* REMOVE ITEM */
//   if (e.target.classList.contains('cart-drawer__item-delete')) {
//     e.preventDefault();

//     const itemId = e.target.getAttribute('data-item-id');

//     if (itemId) {
//       await updateCart(itemId, 0);
//     }
//     return;
//   }
// });

// /* ===============================
//    VARIANT CHANGE SUPPORT
// ================================= */
// document.addEventListener('change', function (e) {
//   if (
//     e.target.matches('select[name="id"]') ||
//     e.target.matches('input[name="id"]')
//   ) {
//     setTimeout(() => {
//       initializeCartDrawerEvents();
//     }, 300);
//   }
// });

// /* ===============================
//    PAGE LOAD
// ================================= */
// document.addEventListener('DOMContentLoaded', function () {
//   initializeCartDrawerEvents();
// });






/* ===============================
   MONEY FORMAT
================================= */
function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.money_format;
  let value = '';

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollars + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

/* ===============================
   GLOBAL ELEMENTS
================================= */
const body = document.body;
const loaderSkeleton = document.querySelector('.loader__skeleton');

/* ===============================
   CART DRAWER TOGGLE
================================= */
function toggleCartDrawer(isOpen) {
  const cartDrawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-drawer-overlay');

  if (!cartDrawer || !overlay) return;

  if (isOpen) {
    cartDrawer.style.transform = 'translateX(0)';
    overlay.style.display = 'block';
    body.classList.add('cart-drawer-open');
  } else {
    cartDrawer.style.transform = 'translateX(100%)';
    overlay.style.display = 'none';
    body.classList.remove('cart-drawer-open');
  }
}

/* ===============================
   REFRESH CART DRAWER
================================= */
async function refreshCartDrawer() {
  try {
    const response = await fetch('?section_id=cart-drawer');
    const cartData = await response.text();

    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(cartData, 'text/html');

    const newBody = htmlDoc.querySelector('.cart-drawer__body');
    const currentBody = document.querySelector('.cart-drawer__body');

    if (newBody && currentBody) {
      currentBody.innerHTML = newBody.innerHTML;
    }

    const cartForm = htmlDoc.querySelector('#cart-drawer__form');
    const cartCount = cartForm
      ? parseInt(cartForm.getAttribute('data-cart-count'), 10)
      : 0;

    const basketCount = document.querySelector('#CartCount [data-cart-count]');
    const cartCountWrapper = document.querySelector('#CartCount');

    if (basketCount) basketCount.innerHTML = cartCount;

    if (cartCountWrapper) {
      if (cartCount === 0) {
        cartCountWrapper.classList.add('hide');
      } else {
        cartCountWrapper.classList.remove('hide');
      }
    }

    initializeCartDrawerEvents();
  } catch (error) {
    console.error('Error refreshing cart drawer:', error);
  }
}

/* ===============================
   ADD TO CART (OPTIMIZED)
================================= */
async function addToCart(id, quantity = 1) {
  try {
    if (!id) return;

    // Show loader immediately
    if (loaderSkeleton) loaderSkeleton.style.display = 'block';

    // Start both operations simultaneously
    const addPromise = fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: id,
        quantity: quantity,
      }),
    });

    const [addResponse] = await Promise.all([addPromise]);

    if (!addResponse.ok) {
      throw new Error('Failed to add product');
    }

    // Open drawer immediately, then refresh
    toggleCartDrawer(true);
    await refreshCartDrawer();

  } catch (error) {
    console.error('Error adding to cart:', error);
  } finally {
    if (loaderSkeleton) loaderSkeleton.style.display = 'none';
  }
}

/* ===============================
   UPDATE CART (OPTIMIZED)
================================= */
async function updateCart(itemId, quantity) {
  try {
    if (!itemId) return;

    // Update UI optimistically first
    const quantityInput = document.querySelector(
      `.cart-drawer__item-quantity__val[data-item-id="${itemId}"]`
    );
    if (quantityInput) {
      quantityInput.value = quantity;
    }

    // Show minimal loading state
    if (loaderSkeleton) loaderSkeleton.style.display = 'block';

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: itemId,
        quantity: quantity,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to update cart');
    }

    const updatedCart = await response.json();

    // Quick refresh
    await refreshCartDrawer();

    if (updatedCart.item_count === 0) {
      toggleCartDrawer(false);
    }
  } catch (error) {
    console.error('Error updating cart:', error);
    // Refresh on error to restore correct state
    await refreshCartDrawer();
  } finally {
    if (loaderSkeleton) loaderSkeleton.style.display = 'none';
  }
}

/* ===============================
   DEBOUNCE HELPER
================================= */
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/* ===============================
   INITIALIZE CART DRAWER EVENTS
================================= */
function initializeCartDrawerEvents() {
  const closeButtons = document.querySelectorAll('#close-cart');
  const overlay = document.querySelector('.cart-drawer-overlay');

  closeButtons.forEach((button) => {
    button.onclick = () => toggleCartDrawer(false);
  });

  if (overlay) {
    overlay.onclick = () => toggleCartDrawer(false);
  }
}

/* ===============================
   GLOBAL CLICK EVENTS
================================= */
document.body.addEventListener('click', async function (e) {

  /* OPEN CART DRAWER */
  if (
    e.target.matches('[toggle-cart-drawer]') ||
    e.target.closest('[toggle-cart-drawer]')
  ) {
    e.preventDefault();
    toggleCartDrawer(true);
    refreshCartDrawer();
    return;
  }

  /* PRODUCT PAGE ADD TO CART */
  // const productCartBtn = e.target.closest('.product-form__cart-submit');
  // if (productCartBtn) {
  //   e.preventDefault();

  //   const form =
  //     productCartBtn.closest('form') ||
  //     document.querySelector('form[action="/cart/add"]');

  //   if (!form) return;

  //   const variantInput = form.querySelector('[name="id"]');
  //   const quantityInput = form.querySelector('[name="quantity"]');

  //   const variantId = variantInput ? variantInput.value : null;
  //   const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

  //   if (variantId) {
  //     await addToCart(variantId, quantity);
  //   }
  //   return;
  // }
  /* PRODUCT PAGE ADD TO CART (also handles upsell "Add To Bag" links) */
const productCartBtn = e.target.closest('.product-form__cart-submit');
if (productCartBtn) {
  e.preventDefault();

  // Upsell buttons (cart drawer "You May Also Like") carry the variant id
  // directly on a data attribute instead of living inside a form.
  const upsellVariantId =
    productCartBtn.getAttribute('data-varaint') ||
    productCartBtn.getAttribute('data-variant');

  if (upsellVariantId) {
    await addToCart(upsellVariantId, 1);
    return;
  }

  const form =
    productCartBtn.closest('form') ||
    document.querySelector('form[action="/cart/add"]');

  if (!form) return;

  const variantInput = form.querySelector('[name="id"]');
  const quantityInput = form.querySelector('[name="quantity"]');

  const variantId = variantInput ? variantInput.value : null;
  const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

  if (variantId) {
    await addToCart(variantId, quantity);
  }
  return;
}

  /* QUICK ADD */
  if (
    e.target.id === 'quick-add' ||
    e.target.classList.contains('product-form--atc-button')
  ) {
    e.preventDefault();

    const variantId =
      e.target.getAttribute('data-variant') ||
      e.target.getAttribute('data-varaint');

    if (variantId) {
      await addToCart(variantId, 1);
    }
    return;
  }

  /* COLLECTION QUICK ADD */
  if (e.target.classList.contains('btn--submit')) {
    e.preventDefault();

    const parent = e.target.closest('.main-collection-quick-add');
    if (!parent) return;

    const variantInput = parent.querySelector('#varaint-id__input');
    const quantityInput = parent.querySelector('input[type="number"]');

    const variantId = variantInput ? variantInput.value : null;
    const quantity = quantityInput
      ? parseInt(quantityInput.value, 10)
      : 1;

    if (variantId) {
      await addToCart(variantId, quantity);
    }
    return;
  }

  /* CART QTY MINUS */
  if (e.target.classList.contains('cart-drawer-quantity__minus')) {
    e.preventDefault();

    const quantityInput = e.target.parentElement.querySelector(
      '.cart-drawer__item-quantity__val'
    );

    if (!quantityInput) return;

    const itemId = quantityInput.getAttribute('data-item-id');
    const currentQty = parseInt(quantityInput.value, 10) || 1;
    const newQty = Math.max(currentQty - 1, 0);

    await updateCart(itemId, newQty);
    return;
  }

  /* CART QTY PLUS */
  if (e.target.classList.contains('cart-drawer-quantity__plus')) {
    e.preventDefault();

    const quantityInput = e.target.parentElement.querySelector(
      '.cart-drawer__item-quantity__val'
    );

    if (!quantityInput) return;

    const itemId = quantityInput.getAttribute('data-item-id');
    const currentQty = parseInt(quantityInput.value, 10) || 1;
    const newQty = currentQty + 1;

    await updateCart(itemId, newQty);
    return;
  }

  /* REMOVE ITEM */
  if (e.target.classList.contains('cart-drawer__item-delete')) {
    e.preventDefault();

    const itemId = e.target.getAttribute('data-item-id');

    if (itemId) {
      await updateCart(itemId, 0);
    }
    return;
  }
});

/* ===============================
   VARIANT CHANGE SUPPORT
================================= */
document.addEventListener('change', function (e) {
  if (
    e.target.matches('select[name="id"]') ||
    e.target.matches('input[name="id"]')
  ) {
    setTimeout(() => {
      initializeCartDrawerEvents();
    }, 300);
  }
});

/* ===============================
   PAGE LOAD
================================= */
document.addEventListener('DOMContentLoaded', function () {
  initializeCartDrawerEvents();
});